import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./shared";
import { PHONE, PHONE_HREF, WHATSAPP_LINK, EMAIL, EMAIL_HREF, REGISTERED_ADDRESS } from "../data/site";
import { LANDING_LIST } from "../data/landing";

const NAV = [
  { label: "Gaur Yamuna City", id: "gyc" },
  { label: "Properties", id: "inventory" },
  { label: "Projects", id: "projects" },
  { label: "7th Park View", id: "explore-corridor" },
  { label: "Yamuna Corridor", id: "corridor" },
  { label: "Airport", id: "airport" },
  { label: "Market Insights", id: "insights" },
  { label: "Advisory", id: "advisory" },
  { label: "Contact", id: "contact" },
];

const LEGAL = ["Privacy Policy", "Terms", "Disclaimer", "RERA / Regulatory Information"];

export function Footer() {
  return (
    <footer className="relative bg-[#070707] border-t border-[#D4AF37]/15 pb-24 lg:pb-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-12 mb-14">
          <div className="sm:col-span-2">
            <Logo />
            <p className="mt-6 font-serif-lux text-xl text-[#A1A1AA] italic">&ldquo;Your Gateway to the Yamuna Growth Corridor.&rdquo;</p>
            <div className="mt-6 flex flex-col gap-2 text-sm text-[#71717A]">
              <a href={PHONE_HREF} data-testid="footer-phone-link" className="hover:text-[#F3E5AB] transition-colors w-fit">{PHONE}</a>
              <a href={EMAIL_HREF} data-testid="footer-email-link" className="hover:text-[#F3E5AB] transition-colors w-fit">{EMAIL}</a>
              <a href={WHATSAPP_LINK} data-testid="footer-whatsapp-link" target="_blank" rel="noopener noreferrer" className="hover:text-[#F3E5AB] transition-colors w-fit">WhatsApp the Advisory Desk</a>
              <span>Gaur Yamuna City &bull; Yamuna Expressway &bull; Greater Noida, UP</span>
            </div>
            <div className="mt-6">
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">Registered Office</p>
              <p data-testid="footer-registered-address" className="text-sm text-[#71717A] max-w-xs leading-relaxed">
                {REGISTERED_ADDRESS}
              </p>
            </div>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button data-testid={`footer-nav-${n.id}`} onClick={() => scrollToId(n.id)} className="text-sm text-[#71717A] hover:text-[#F3E5AB] transition-colors">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Guides</p>
            <ul className="space-y-3">
              {LANDING_LIST.map((p) => (
                <li key={p.slug}>
                  <Link to={p.path} data-testid={`footer-guide-${p.slug}`} className="text-sm text-[#71717A] hover:text-[#F3E5AB] transition-colors">
                    {p.tag.replace(" Guide", "")}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Legal</p>
            <ul className="space-y-3">
              {LEGAL.map((l) => (
                <li key={l} className="text-sm text-[#71717A]">{l}</li>
              ))}
            </ul>
            <a href="/admin" data-testid="footer-admin-link" className="inline-block mt-6 text-[11px] uppercase tracking-[0.2em] text-[#3f3f46] hover:text-[#A1A1AA] transition-colors">
              Advisor Login
            </a>
          </div>
        </div>

        <div className="gold-hairline" />

        <p className="mt-8 text-[11px] text-[#52525b] leading-relaxed max-w-5xl" data-testid="footer-disclaimer">
          All property information, prices, availability, specifications and development timelines are subject to
          verification and change. Buyers should independently verify project approvals, RERA registration, title,
          documentation and other relevant information before making any investment decision. Infrastructure and
          development references are labelled by their public status (operational, under development, announced or
          proposed) and do not constitute investment advice or a promise of returns.
        </p>
        <p className="mt-3 text-[10px] text-[#3f3f46] leading-relaxed max-w-5xl" data-testid="footer-photo-credits">
          Site photographs of Gaur Yamuna City courtesy Gaurs Group public media. Yamuna Expressway photograph by
          Qirille and Gaur Yamuna City entrance photograph by Akash0jain via Wikimedia Commons (CC BY-SA). 7th
          Park View renders, master plan and site plan images courtesy Gaursons India Pvt. Ltd. Radiance
          Realtors is an independent channel partner and is not the developer.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4 text-[10px] uppercase tracking-[0.2em] text-[#3f3f46]">
          <span>&copy; {new Date().getFullYear()} Radiance Realtors. All rights reserved.</span>
          <span>Where Vision Meets Opportunity.</span>
        </div>
      </div>
    </footer>
  );
}
